import { useCallback, useMemo } from 'react';
import Alert from '@mui/material/Alert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import { getAllCampaigns, getSelectedCampaign } from 'features/views/dashboard/campaignManagement/selectors';
import { setSelectedCampaign } from 'features/views/dashboard/campaignManagement/slice';

import CampaignTableRow from './CampaignTableRow';

export const CampaignsTableBody = () => {
	const dispatch = useDispatch();

	const allCampaigns = useSelector(getAllCampaigns);
	const selectedCampaign = useSelector(getSelectedCampaign);

	const handleCampaignSelectChange = useCallback(
		(id) => () => {
			dispatch(setSelectedCampaign(id));
		},
		[dispatch],
	);

	const noResults = useMemo(
		() => (
			<TableRow>
				<TableCell colSpan={2}>
					<Alert severity="info">{getMessage('dashboard:campaignManagement.noCampaigns')}</Alert>
				</TableCell>
			</TableRow>
		),
		[],
	);

	return (
		<TableBody>
			{!isNilOrEmpty(allCampaigns) ? (
				<>
					<TableRow onClick={handleCampaignSelectChange(null)}>
						<TableCell colSpan={2}>
							<Stack
								direction="row"
								sx={{
									ml: 1.5,
									alignItems: 'center',
								}}
							>
								<FormControlLabel
									control={<Radio size="small" checked={isNilOrEmpty(selectedCampaign)} />}
								/>
								<Typography variant="body1">
									{getMessage('dashboard:campaignManagement.allCampaigns')}
								</Typography>
							</Stack>
						</TableCell>
					</TableRow>
					{allCampaigns.map((campaign) => (
						<CampaignTableRow
							key={campaign?.id}
							campaign={campaign}
							onClick={handleCampaignSelectChange}
							selectedCampaign={selectedCampaign}
						/>
					))}
				</>
			) : (
				noResults
			)}
		</TableBody>
	);
};

export default CampaignsTableBody;
